import ReactCountryFlag from "react-country-flag";

export const languages = [
  {
    code: "en",
    name: "English",
    country: "unitedKingdom",
    countryCode: "GB",
  },
  {
    code: "de",
    name: "Deutsch",
    country: "germany",
    countryCode: "DE",
  },
  // {
  //   code: "ar",
  //   name: "Arabic",
  //   country: "sadiArabia",
  //   countryCode: "SA",
  // },
  {
    code: "it",
    name: "Italiano",
    country: "italy",
    countryCode: "IT",
  },
  {
    code: "fr",
    name: "Français",
    country: "france",
    countryCode: "FR",
  },
  {
    code: "nl",
    name: "Nederlands",
    country: "netherlands",
    countryCode: "NL",
  },
  {
    code: "ro",
    name: "Română",
    country: "romania",
    countryCode: "RO",
  },
  {
    code: "pt",
    name: "Português",
    country: "portugal",
    countryCode: "PT",
  },
  {
    code: "sv",
    name: "Svenska",
    country: "sweden",
    countryCode: "SE",
  },
  {
    code: "pl",
    name: "Polski",
    country: "poland",
    countryCode: "PL",
  },
];

// في الكومبوننت:
